import api from "../../api";
import {SystemAgentDomain} from "../../Types";
import {param, typedQuery} from "../typing";

export const systemAgentsByDomain = typedQuery(
  ["systemAgentsByDomain", param<SystemAgentDomain>("systemAgentDomain")],
  async domain => await api.systemAgents.list(domain),
);

export const systemAgents = typedQuery(["systemAgents"], async () => await api.systemAgents.listAll());

export const systemAgentsDefault = typedQuery(
  ["systemAgentsDefault"],
  async () => await api.systemAgents.listDefault(),
);
